import Vue from 'vue'
import VueRouter from 'vue-router'
import VueHead from 'vue-head'
import Home from '../views/index.vue'

Vue.use(VueHead)
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
